import resolveComponent from '../resolveComponent';

 
const DataManageConfig = [
  {
    path: `/:appId?/data-manage`,
    label: '数据管理',
    exact: false,
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `/:appId?/data-manage/account`,
        exact: true,
        label: '账号数据',
        component: resolveComponent(() => import('@src/pages/app/dataManage/account')),
      },
      {
        path: `/:appId?/data-manage/operation`,
        exact: true,
        label: '运营数据',
        component: resolveComponent(() => import('@src/pages/app/dataManage/operation')),
      },
      {
        path: `/:appId?/data-manage/detail`,
        exact: true,
        label: '线索明细',
        component: resolveComponent(() => import('@src/pages/app/dataManage/detail')),
      },
    ],
  },
];

export default DataManageConfig;
